/**
 * @generated SignedSource<<f471ddc97dc87c11c42e9f98ae415115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_ToolDataQuery$variables = {
  modelId: string;
  pricingFirst: number;
  productId: number;
};
export type productSidePanelContent_ToolDataQuery$data = {
  readonly additionalAttributesByProduct: {
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly aiProductStagingRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly aiVirtualModelRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly allAIStagingRules: ReadonlyArray<{
    readonly ruleID: number;
  }>;
  readonly allAIVirtualModelRules: ReadonlyArray<{
    readonly ruleID: number;
  }>;
  readonly allAreaBackgroundRules: ReadonlyArray<{
    readonly areaBackgroundRuleID: number;
  }>;
  readonly allMoqRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }> | null;
  } | null;
  readonly allQuoteRules: ReadonlyArray<{
    readonly quoteRuleID: number;
  }>;
  readonly areaBackgroundRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly designTemplates: ReadonlyArray<{
    readonly designTemplateId: number;
    readonly name: string;
    readonly previewUrl: string;
  }>;
  readonly designWithAISettings: ReadonlyArray<{
    readonly settingsID: number;
  }>;
  readonly gridRules: ReadonlyArray<{
    readonly gridRuleID: number;
  } | null> | null;
  readonly gridRulesByProduct: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly placementsOutput: ReadonlyArray<{
    readonly placementOutputID: number;
  }>;
  readonly pricings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly pricingsDetailed: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
  readonly productMultipleVariantsRule: {
    readonly attributeCodes: ReadonlyArray<string>;
  };
  readonly profanityFilterRules: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    } | null> | null;
  } | null;
  readonly profanityFilterRulesForProduct: {
    readonly printTypeRules: ReadonlyArray<{
      readonly key: number;
      readonly value: {
        readonly ruleID: number;
        readonly ruleName: string;
      };
    }>;
    readonly productRule: {
      readonly ruleID: number;
      readonly ruleName: string;
    } | null;
  } | null;
  readonly shapesAssignmentsForProduct: {
    readonly forProduct: boolean | null;
    readonly printTypesIDs: ReadonlyArray<number>;
  };
  readonly toolUsageRuleByToolType: {
    readonly toolUsageRuleID: number;
  } | null;
};
export type productSidePanelContent_ToolDataQuery = {
  response: productSidePanelContent_ToolDataQuery$data;
  variables: productSidePanelContent_ToolDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pricingFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "designTemplateId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "productID",
  "variableName": "productId"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "ShapesAssignmentsForProduct",
  "kind": "LinkedField",
  "name": "shapesAssignmentsForProduct",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forProduct",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypesIDs",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PricingGroup",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "pricingFirst"
    },
    (v7/*: any*/)
  ],
  "concreteType": "PricingsDetailedConnection",
  "kind": "LinkedField",
  "name": "pricingsDetailed",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingsDetailedEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleID",
  "storageKey": null
},
v14 = [
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleName",
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "ProfanityFilterAssignmentsForProduct",
  "kind": "LinkedField",
  "name": "profanityFilterRulesForProduct",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfanityFilterRuleRef",
      "kind": "LinkedField",
      "name": "productRule",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValuePairOfInt64AndProfanityFilterRuleRef",
      "kind": "LinkedField",
      "name": "printTypeRules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterRuleRef",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v10/*: any*/),
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "AIProductStagingRuleOutput",
  "kind": "LinkedField",
  "name": "aiProductStagingRulesByProduct",
  "plural": true,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "AIVirtualModelRuleOutput",
  "kind": "LinkedField",
  "name": "aiVirtualModelRulesByProduct",
  "plural": true,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "GridRule",
  "kind": "LinkedField",
  "name": "gridRulesByProduct",
  "plural": true,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "AreaBackgroundRuleTool",
  "kind": "LinkedField",
  "name": "areaBackgroundRulesByProduct",
  "plural": true,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productID",
      "variableName": "modelId"
    }
  ],
  "concreteType": "AdditionalAttribute",
  "kind": "LinkedField",
  "name": "additionalAttributesByProduct",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalAttributeID",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v23 = [
  (v10/*: any*/)
],
v24 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "ProfanityFilterRulesConnection",
  "kind": "LinkedField",
  "name": "profanityFilterRules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfanityFilterRule",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "profanityFilterRules(first:1)"
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v26 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "PrintTypesConnection",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PrintTypesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PrintType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "printTypeID",
              "storageKey": null
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "printTypes(first:200)"
},
v27 = {
  "alias": null,
  "args": (v25/*: any*/),
  "concreteType": "PricingsConnection",
  "kind": "LinkedField",
  "name": "pricings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PricingsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "pricings(first:200)"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaBackgroundRuleID",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gridRuleID",
  "storageKey": null
},
v30 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "modelId"
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placementOutputID",
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "toolType",
    "value": "CustomizerAIImageGenerator"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toolUsageRuleID",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settingsID",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productId",
      "variableName": "modelId"
    }
  ],
  "concreteType": "ProductMultipleVariantsRule",
  "kind": "LinkedField",
  "name": "productMultipleVariantsRule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeCodes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = [
  (v13/*: any*/)
],
v37 = {
  "alias": "allMoqRules",
  "args": (v22/*: any*/),
  "concreteType": "MoqRulesConnection",
  "kind": "LinkedField",
  "name": "moqRules",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MoqRulesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MoqRule",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v23/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "moqRules(first:1)"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRuleID",
  "storageKey": null
},
v39 = [
  (v13/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DesignTemplate",
        "kind": "LinkedField",
        "name": "designTemplates",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v24/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      {
        "alias": "allAreaBackgroundRules",
        "args": null,
        "concreteType": "AreaBackgroundRuleTool",
        "kind": "LinkedField",
        "name": "areaBackgroundRules",
        "plural": true,
        "selections": [
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GridRule",
        "kind": "LinkedField",
        "name": "gridRules",
        "plural": true,
        "selections": [
          (v29/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v30/*: any*/),
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementsOutput",
        "plural": true,
        "selections": [
          (v31/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v32/*: any*/),
        "concreteType": "ToolUsageRuleInfo",
        "kind": "LinkedField",
        "name": "toolUsageRuleByToolType",
        "plural": false,
        "selections": [
          (v33/*: any*/)
        ],
        "storageKey": "toolUsageRuleByToolType(toolType:\"CustomizerAIImageGenerator\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignWithAISettingInfoDTO",
        "kind": "LinkedField",
        "name": "designWithAISettings",
        "plural": true,
        "selections": [
          (v34/*: any*/)
        ],
        "storageKey": null
      },
      (v35/*: any*/),
      {
        "alias": "allAIStagingRules",
        "args": null,
        "concreteType": "AIProductStagingRuleInfoOutput",
        "kind": "LinkedField",
        "name": "aiProductStagingRules",
        "plural": true,
        "selections": (v36/*: any*/),
        "storageKey": null
      },
      {
        "alias": "allAIVirtualModelRules",
        "args": null,
        "concreteType": "AIVirtualModelRuleInfoOutput",
        "kind": "LinkedField",
        "name": "aiVirtualModelRules",
        "plural": true,
        "selections": (v36/*: any*/),
        "storageKey": null
      },
      (v37/*: any*/),
      {
        "alias": "allQuoteRules",
        "args": null,
        "concreteType": "QuoteRule",
        "kind": "LinkedField",
        "name": "quoteRulesList",
        "plural": true,
        "selections": [
          (v38/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DesignTemplate",
        "kind": "LinkedField",
        "name": "designTemplates",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v24/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      {
        "alias": "allAreaBackgroundRules",
        "args": null,
        "concreteType": "AreaBackgroundRuleTool",
        "kind": "LinkedField",
        "name": "areaBackgroundRules",
        "plural": true,
        "selections": [
          (v28/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GridRule",
        "kind": "LinkedField",
        "name": "gridRules",
        "plural": true,
        "selections": [
          (v29/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v30/*: any*/),
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementsOutput",
        "plural": true,
        "selections": [
          (v31/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v32/*: any*/),
        "concreteType": "ToolUsageRuleInfo",
        "kind": "LinkedField",
        "name": "toolUsageRuleByToolType",
        "plural": false,
        "selections": [
          (v33/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": "toolUsageRuleByToolType(toolType:\"CustomizerAIImageGenerator\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignWithAISettingInfoDTO",
        "kind": "LinkedField",
        "name": "designWithAISettings",
        "plural": true,
        "selections": [
          (v34/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      (v35/*: any*/),
      {
        "alias": "allAIStagingRules",
        "args": null,
        "concreteType": "AIProductStagingRuleInfoOutput",
        "kind": "LinkedField",
        "name": "aiProductStagingRules",
        "plural": true,
        "selections": (v39/*: any*/),
        "storageKey": null
      },
      {
        "alias": "allAIVirtualModelRules",
        "args": null,
        "concreteType": "AIVirtualModelRuleInfoOutput",
        "kind": "LinkedField",
        "name": "aiVirtualModelRules",
        "plural": true,
        "selections": (v39/*: any*/),
        "storageKey": null
      },
      (v37/*: any*/),
      {
        "alias": "allQuoteRules",
        "args": null,
        "concreteType": "QuoteRule",
        "kind": "LinkedField",
        "name": "quoteRulesList",
        "plural": true,
        "selections": [
          (v38/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd68d6baa47e53f1c5fbf5e24d7faa4e",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ToolDataQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ToolDataQuery(\n  $productId: Long!\n  $modelId: ID!\n  $pricingFirst: Int!\n) {\n  designTemplates(productId: $productId) {\n    designTemplateId\n    name\n    previewUrl\n    id\n  }\n  shapesAssignmentsForProduct(productID: $productId) {\n    forProduct\n    printTypesIDs\n  }\n  pricingsDetailed(productID: $productId, first: $pricingFirst) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  profanityFilterRulesForProduct(productID: $productId) {\n    productRule {\n      ruleID\n      ruleName\n    }\n    printTypeRules {\n      key\n      value {\n        ruleID\n        ruleName\n      }\n    }\n  }\n  aiProductStagingRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  aiVirtualModelRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  gridRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  areaBackgroundRulesByProduct(productID: $productId) {\n    id\n    name\n  }\n  additionalAttributesByProduct(productID: $modelId) {\n    id\n    additionalAttributeID\n    name\n  }\n  profanityFilterRules(first: 1) {\n    nodes {\n      id\n    }\n  }\n  printTypes(first: 200) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n  pricings(first: 200) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  allAreaBackgroundRules: areaBackgroundRules {\n    areaBackgroundRuleID\n    id\n  }\n  gridRules {\n    gridRuleID\n    id\n  }\n  placementsOutput(id: $modelId) {\n    placementOutputID\n    id\n  }\n  toolUsageRuleByToolType(toolType: CustomizerAIImageGenerator) {\n    toolUsageRuleID\n    id\n  }\n  designWithAISettings {\n    settingsID\n    id\n  }\n  productMultipleVariantsRule(productId: $modelId) {\n    attributeCodes\n  }\n  allAIStagingRules: aiProductStagingRules {\n    ruleID\n    id\n  }\n  allAIVirtualModelRules: aiVirtualModelRules {\n    ruleID\n    id\n  }\n  allMoqRules: moqRules(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  allQuoteRules: quoteRulesList {\n    quoteRuleID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "66ec1947ce19cbe8b924571ff20c0356";

export default node;
